document.addEventListener('click', function(e) {
  var promoToggle = e.target.closest('[data-k7-mobile-nav-promo-toggle]');
  if (promoToggle) {
    e.preventDefault();
    e.stopPropagation();
    var promo = promoToggle.closest('[data-k7-mobile-nav-promo]');
    if (!promo) return;
    var collapsed = promo.classList.toggle('k7-promo-collapsed');
    promoToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    promoToggle.setAttribute('aria-label', collapsed ? promoToggle.getAttribute('data-label-more') : promoToggle.getAttribute('data-label-less'));
    return;
  }
  var lipscoreWrap = e.target.closest('[data-lipscore-scroll-to-reviews]');
  if (lipscoreWrap && !lipscoreWrap.closest('quick-buy-drawer')) {
    var reviewEl = document.getElementById('lipscore-review-list') || document.querySelector('.lipscore-review-list');
    if (reviewEl) {
      var clickedLink = e.target.closest('a[href]');
      if (clickedLink) {
        var href = (clickedLink.getAttribute('href') || '').trim();
        if (/^https?:\/\//i.test(href) || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return;
        if (href.indexOf('#') === 0 && href.length > 1 && href !== '#lipscore-review-list' && href.indexOf('lipscore-review-list') === -1) return;
      }
      e.preventDefault();
      reviewEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  }
  var btn = e.target.closest('[data-action="open-cart-drawer"]');
  if (btn) {
    e.preventDefault();
    var currentDrawer = btn.closest('quick-buy-drawer, cart-notification-drawer');
    if (currentDrawer && currentDrawer.hide) currentDrawer.hide();
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && cartDrawer.show) cartDrawer.show();
    return;
  }
  var link = e.target.closest('a[data-mobile-quick-add]');
  if (link && window.matchMedia('(pointer: coarse)').matches) {
    e.preventDefault();
    var container = link.closest('.product-card__figure, .k7-product-carousel__media');
    var quickAddBtn = container && container.querySelector('.product-card__quick-buy button, .k7-product-carousel__quick-buy button');
    if (quickAddBtn) quickAddBtn.click();
  }
});

function initK7QuantityPresetInDrawer(drawer) {
  if (!drawer || !drawer.querySelectorAll) return;
  var containers = drawer.querySelectorAll('.k7-qty-preset:not([data-qty-initialized])');
  containers.forEach(function(container) {
    var blocks = container.querySelectorAll('.k7-qty-preset__block');
    var input = container.querySelector('.k7-qty-preset__input');
    if (!input) return;
    var selectBlock = function(block) {
      blocks.forEach(function(b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      block.classList.add('is-selected');
      block.setAttribute('aria-checked', 'true');
      input.value = block.getAttribute('data-quantity');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    blocks.forEach(function(block) {
      block.addEventListener('click', function() { selectBlock(block); });
    });
    container.setAttribute('data-qty-initialized', 'true');
  });
}

function setupK7QuickBuyDrawerObserver() {
  var observer = new MutationObserver(function() {
    document.querySelectorAll('quick-buy-drawer').forEach(initK7QuantityPresetInDrawer);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll('quick-buy-drawer').forEach(initK7QuantityPresetInDrawer);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupK7QuickBuyDrawerObserver);
} else {
  setupK7QuickBuyDrawerObserver();
}

function k7ToggleButtonGroupTrackScrollable(track) {
  if (!track) return;
  var wide = track.scrollWidth > track.clientWidth + 1;
  track.classList.toggle('is-scrollable', wide);
}

function k7FindOverlayProgressBar(track) {
  if (!track || !track.id) return null;
  var parent = track.parentNode;
  if (!parent) return null;
  return parent.querySelector('scroll-progress[observes="' + track.id + '"]');
}

function k7UpdateOverlayProgress(track) {
  if (!track) return;
  var bar = k7FindOverlayProgressBar(track);
  if (!bar) return;
  var sw = track.scrollWidth;
  var cw = track.clientWidth;
  if (sw <= 0 || cw <= 0 || sw <= cw) {
    bar.style.setProperty('--scroll-progress', '1');
    return;
  }
  var rtl = (document.documentElement.dir || document.dir || 'ltr') !== 'ltr';
  var scrollLeft = rtl ? Math.abs(track.scrollLeft) : track.scrollLeft;
  var p = (scrollLeft + cw) / sw;
  if (!isFinite(p)) p = 1;
  if (p < 0) p = 0;
  if (p > 1) p = 1;
  bar.style.setProperty('--scroll-progress', p.toFixed(6));
}

function k7AnimateScrollCenter(track, element, duration) {
  duration = typeof duration === 'number' ? duration : 1040;
  var easeOutCubic = function(t) {
    return 1 - Math.pow(1 - t, 3);
  };

  if (getComputedStyle(track).direction === 'rtl') {
    element.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    setTimeout(function() {
      k7UpdateOverlayProgress(track);
      requestAnimationFrame(function() {
        k7UpdateOverlayProgress(track);
      });
    }, 1100);
    return;
  }

  var measureTargetLeft = function() {
    var pr = track.getBoundingClientRect();
    var er = element.getBoundingClientRect();
    var delta = er.left + er.width / 2 - (pr.left + pr.width / 2);
    var raw = track.scrollLeft + delta;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    return Math.max(0, Math.min(raw, max));
  };

  var startLeft = track.scrollLeft;
  var endLeft = measureTargetLeft();
  if (Math.abs(endLeft - startLeft) < 2) {
    k7UpdateOverlayProgress(track);
    return;
  }

  var t0 = null;
  function step(ts) {
    if (t0 === null) t0 = ts;
    var u = Math.min(1, (ts - t0) / duration);
    track.scrollLeft = startLeft + (endLeft - startLeft) * easeOutCubic(u);
    k7UpdateOverlayProgress(track);
    if (u < 1) {
      requestAnimationFrame(step);
    } else {
      k7UpdateOverlayProgress(track);
    }
  }
  requestAnimationFrame(step);
}

function k7RunOverlaySelectedButtonCenter(scope) {
  var ctx = scope && scope.querySelectorAll ? scope : document;
  ctx.querySelectorAll('.shopify-section--image-with-text-overlay .k7-button-group__track.scroll-area').forEach(k7ToggleButtonGroupTrackScrollable);
  ctx.querySelectorAll('.shopify-section--image-with-text-overlay .k7-button-group__track.is-scrollable').forEach(function(track) {
    var btn = track.querySelector('.k7-button-group__btn.is-selected');
    if (!btn || track.dataset.k7SelectedCenterDone === '1') return;
    track.dataset.k7SelectedCenterDone = '1';
    k7AnimateScrollCenter(track, btn, 1040);
  });
}

function k7ScheduleOverlaySelectedCenter(scope) {
  var ctx = scope && scope.querySelectorAll ? scope : document;
  function runAfterLayout() {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        setTimeout(function() {
          k7RunOverlaySelectedButtonCenter(ctx);
        }, 100);
      });
    });
  }

  function afterLoad() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(runAfterLayout).catch(runAfterLayout);
    } else {
      runAfterLayout();
    }
  }

  if (document.readyState === 'complete') {
    afterLoad();
  } else {
    window.addEventListener('load', afterLoad, { once: true });
  }
}

function initK7ImageOverlayButtonGroupTracks(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.shopify-section--image-with-text-overlay .k7-button-group__track.scroll-area').forEach(function(track) {
    if (track.dataset.k7TrackInit === '1') return;
    track.dataset.k7TrackInit = '1';
    var ro = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(function() {
          k7ToggleButtonGroupTrackScrollable(track);
          k7UpdateOverlayProgress(track);
        })
      : null;
    if (ro) {
      ro.observe(track);
      var inner = track.querySelector('.k7-button-group__inner');
      if (inner) ro.observe(inner);
    }
    track.addEventListener('scroll', function() {
      k7ToggleButtonGroupTrackScrollable(track);
      k7UpdateOverlayProgress(track);
    }, { passive: true });
    k7ToggleButtonGroupTrackScrollable(track);
    k7UpdateOverlayProgress(track);
  });
}

function k7BootImageOverlayButtonGroups(scope) {
  initK7ImageOverlayButtonGroupTracks(scope);
  k7ScheduleOverlaySelectedCenter(scope);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    k7BootImageOverlayButtonGroups(document);
  });
} else {
  k7BootImageOverlayButtonGroups(document);
}

document.addEventListener('shopify:section:load', function(e) {
  if (!e.target || !e.target.querySelectorAll) return;
  e.target.querySelectorAll('.k7-button-group__track.scroll-area').forEach(function(track) {
    track.removeAttribute('data-k7-track-init');
    track.removeAttribute('data-k7-selected-center-done');
  });
  k7BootImageOverlayButtonGroups(e.target);
});

/* ========================================
   CART DRAWER SYNC
   ======================================== */

function k7GetCartDrawerSectionId() {
  var cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return null;
  var wrapper = cartDrawer.closest('.shopify-section');
  if (wrapper && wrapper.id) return wrapper.id.replace('shopify-section-', '');
  return cartDrawer.getAttribute('data-section-id') || null;
}

function k7CollectCartSections() {
  var sections = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections: sections }
  }));
  if (!sections.length) {
    var sectionId = k7GetCartDrawerSectionId();
    if (sectionId) sections.push(sectionId);
  }
  return sections;
}

function k7FormatCartSections(sections) {
  if (!sections || !sections.length) return '';
  return Array.isArray(sections) ? sections.join(',') : String(sections);
}

window.k7Cart = {
  getSectionId: k7GetCartDrawerSectionId,
  collectSections: k7CollectCartSections,
  formatSections: k7FormatCartSections
};

function initK7CartDrawerSync() {
  var refreshQueued = false;

  document.addEventListener('cart:change', function(event) {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer || !event.detail || !event.detail.cart) return;

    var sectionId = k7GetCartDrawerSectionId();
    if (!sectionId) return;

    var sections = event.detail.cart.sections;
    if (sections && sections[sectionId]) return;

    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(function() {
      refreshQueued = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7CartDrawerSync, { once: true });
} else {
  initK7CartDrawerSync();
}

function k7CloseKiModal(modal) {
  if (!modal || modal.hidden) return;
  modal.hidden = true;
  document.documentElement.classList.remove('lock');
  document.querySelectorAll('.k7-ki-badge[aria-controls="' + modal.id + '"]').forEach(function(badge) {
    badge.setAttribute('aria-expanded', 'false');
  });
  if (modal._k7KiFocusReturn && typeof modal._k7KiFocusReturn.focus === 'function') {
    modal._k7KiFocusReturn.focus();
  }
  modal._k7KiFocusReturn = null;
}

function k7OpenKiModal(modal, trigger) {
  if (!modal) return;
  document.querySelectorAll('.k7-ki-modal:not([hidden])').forEach(function(openModal) {
    if (openModal !== modal) k7CloseKiModal(openModal);
  });
  modal.hidden = false;
  document.documentElement.classList.add('lock');
  modal._k7KiFocusReturn = trigger || null;
  if (trigger) trigger.setAttribute('aria-expanded', 'true');
  var closeButton = modal.querySelector('.k7-ki-modal__close');
  if (closeButton) closeButton.focus();
}

function initK7KiBadge() {
  document.querySelectorAll('.k7-ki-badge:not([data-initialized])').forEach(function(badge) {
    badge.setAttribute('data-initialized', 'true');
    badge.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      var modalId = badge.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;
      if (modal.hidden) {
        k7OpenKiModal(modal, badge);
      } else {
        k7CloseKiModal(modal);
      }
    });
    badge.addEventListener('pointerdown', function(event) {
      event.stopPropagation();
    });
  });

  document.querySelectorAll('.k7-ki-modal:not([data-initialized])').forEach(function(modal) {
    modal.setAttribute('data-initialized', 'true');
    modal.querySelectorAll('[data-k7-ki-close]').forEach(function(closeEl) {
      closeEl.addEventListener('click', function(event) {
        event.preventDefault();
        k7CloseKiModal(modal);
      });
    });
  });
}

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.k7-ki-modal:not([hidden])').forEach(k7CloseKiModal);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7KiBadge, { once: true });
} else {
  initK7KiBadge();
}

document.addEventListener('shopify:section:load', function() {
  setTimeout(initK7KiBadge, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(initK7KiBadge, 100);
});

/* ========================================
 PRODUCT GALLERY DESKTOP HERO
 ======================================== */

function initK7HeroGallery() {
  var galleries = document.querySelectorAll('.product-gallery--desktop-hero');
  var desktopQuery = window.matchMedia('(min-width: 1000px)');

  galleries.forEach(function(gallery) {
    if (gallery.hasAttribute('data-k7-hero-ready')) return;
    gallery.setAttribute('data-k7-hero-ready', '');

    var syncSelectedSlide = function() {
      var carousel = gallery.querySelector('media-carousel');
      if (!carousel || typeof carousel.select !== 'function') return;
      var selected = carousel.selectedSlide;
      if (desktopQuery.matches && selected && selected.classList.contains('k7-product-gallery__below-media')) {
        var firstVisible = carousel.visibleItems && carousel.visibleItems[0];
        if (firstVisible) {
          carousel.select(carousel.items.indexOf(firstVisible), { animate: false, force: true });
        }
      }
    };

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', syncSelectedSlide);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(syncSelectedSlide);
    }

    syncSelectedSlide();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7HeroGallery, { once: true });
} else {
  initK7HeroGallery();
}

document.addEventListener('shopify:section:load', function() {
  setTimeout(initK7HeroGallery, 100);
});

document.addEventListener('product:rerender', function() {
  setTimeout(initK7HeroGallery, 100);
});

/* k7-product-switcher-expand start */

function initK7ProductSwitcherExpand(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var switchers = scope.querySelectorAll ? scope.querySelectorAll('.k7-product-switcher--stacked') : [];

  if (scope.classList && scope.classList.contains('k7-product-switcher--stacked')) {
    switchers = [scope];
  }

  switchers.forEach(function(switcher) {
    if (switcher.dataset.expandBound === 'true') return;
    switcher.dataset.expandBound = 'true';

    var moreButton = switcher.querySelector('[data-switcher-more]');
    var lessButton = switcher.querySelector('[data-switcher-less]');

    function setExpanded(expanded) {
      switcher.classList.toggle('is-expanded', expanded);
      if (moreButton) moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (moreButton) {
      moreButton.addEventListener('click', function() {
        setExpanded(true);
      });
    }

    if (lessButton) {
      lessButton.addEventListener('click', function() {
        setExpanded(false);
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initK7ProductSwitcherExpand();
  }, { once: true });
} else {
  initK7ProductSwitcherExpand();
}

document.addEventListener('shopify:section:load', function(event) {
  initK7ProductSwitcherExpand(event.target);
});

/* k7-product-switcher-expand end */

/* k7 product switcher menu start */

function setK7FlavorPickerOpen(picker, open) {
  var trigger = picker.querySelector('[data-k7-flavor-trigger]');
  var panel = picker.querySelector('[data-k7-flavor-panel]');
  var clip = picker.querySelector('[data-k7-flavor-clip]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  picker.classList.toggle('is-open', open);
  if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (panel) {
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.inert = !open;
  }
  if (!clip) return;

  if (clip._k7FlavorEnd) {
    clip.removeEventListener('transitionend', clip._k7FlavorEnd);
    clip._k7FlavorEnd = null;
  }

  clip.style.overflow = 'hidden';

  if (reduce) {
    clip.style.height = open ? 'auto' : '0px';
    if (open) clip.style.overflow = 'visible';
    return;
  }

  if (open) {
    var start = clip.offsetHeight;
    var target = clip.scrollHeight;
    clip.style.height = start + 'px';
    clip.offsetHeight;
    clip.style.height = target + 'px';
    clip._k7FlavorEnd = function (event) {
      if (event.propertyName !== 'height' || !picker.classList.contains('is-open')) return;
      clip.removeEventListener('transitionend', clip._k7FlavorEnd);
      clip._k7FlavorEnd = null;
      clip.style.height = 'auto';
      clip.style.overflow = 'visible';
    };
    clip.addEventListener('transitionend', clip._k7FlavorEnd);
  } else {
    clip.style.height = clip.offsetHeight + 'px';
    clip.offsetHeight;
    clip.style.height = '0px';
  }
}

function initK7FlavorPicker(picker) {
  if (!picker || picker.dataset.k7FlavorPickerReady === 'true') return;
  var trigger = picker.querySelector('[data-k7-flavor-trigger]');
  if (!trigger) return;
  picker.dataset.k7FlavorPickerReady = 'true';

  if (picker.classList.contains('is-open')) {
    var clip = picker.querySelector('[data-k7-flavor-clip]');
    if (clip) {
      clip.style.height = 'auto';
      clip.style.overflow = 'visible';
    }
  }

  trigger.addEventListener('click', function () {
    setK7FlavorPickerOpen(picker, !picker.classList.contains('is-open'));
  });
}

function initK7ProductSwitcherMenu(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var pickers = scope.querySelectorAll ? scope.querySelectorAll('[data-k7-flavor-picker]') : [];

  if (scope.matches && scope.matches('[data-k7-flavor-picker]')) {
    pickers = [scope];
  }

  pickers.forEach(initK7FlavorPicker);

  if (document.documentElement.dataset.k7FlavorPickerEvents === 'true') return;
  document.documentElement.dataset.k7FlavorPickerEvents = 'true';

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-k7-flavor-picker].is-open').forEach(function (picker) {
      if (picker.contains(event.target)) return;
      setK7FlavorPickerOpen(picker, false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-k7-flavor-picker].is-open').forEach(function (picker) {
      var trigger = picker.querySelector('[data-k7-flavor-trigger]');
      setK7FlavorPickerOpen(picker, false);
      if (trigger && picker.contains(document.activeElement)) trigger.focus();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initK7ProductSwitcherMenu();
  }, { once: true });
} else {
  initK7ProductSwitcherMenu();
}

document.addEventListener('shopify:section:load', function (event) {
  initK7ProductSwitcherMenu(event.target);
});

document.addEventListener('product:rerender', function () {
  initK7ProductSwitcherMenu(document);
});

/* k7 product switcher menu end */

/* k7-set-accordion-switcher start */

function initK7SetAccordionSwitcher(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var switchers = scope.querySelectorAll ? scope.querySelectorAll('[data-k7-set-switcher]') : [];

  if (scope.hasAttribute && scope.hasAttribute('data-k7-set-switcher')) {
    switchers = [scope];
  }

  switchers.forEach(function(switcher) {
    if (switcher.dataset.setSwitcherBound === 'true') return;
    switcher.dataset.setSwitcherBound = 'true';

    switcher.addEventListener('click', function(event) {
      var button = event.target.closest('[data-k7-set-switch]');
      if (!button || !switcher.contains(button)) return;

      var productId = button.getAttribute('data-k7-set-switch');
      if (!productId) return;

      document.querySelectorAll('[data-k7-set-switcher]').forEach(function(group) {
        group.querySelectorAll('[data-k7-set-switch]').forEach(function(tab) {
          var selected = tab.getAttribute('data-k7-set-switch') === productId;
          tab.classList.toggle('is-selected', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        });

        group.querySelectorAll('[data-k7-set-panel]').forEach(function(panel) {
          panel.hidden = panel.getAttribute('data-k7-set-panel') !== productId;
        });
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initK7SetAccordionSwitcher();
  }, { once: true });
} else {
  initK7SetAccordionSwitcher();
}

document.addEventListener('shopify:section:load', function(event) {
  initK7SetAccordionSwitcher(event.target);
});

/* k7-set-accordion-switcher end */

/* k7-award-banner start */

function k7AwardBannerUpdate() {
  var mq = window.matchMedia('(max-width: 699px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var banners = document.querySelectorAll('[data-k7-award-banner]');

  banners.forEach(function(banner) {
    var media = banner.querySelector('.k7-award-banner__media');
    var content = banner.querySelector('.k7-award-banner__content');
    if (!media || !content) return;

    if (!mq.matches || reduceMotion.matches) {
      banner.style.setProperty('--k7-award-scale', '1');
      return;
    }

    var mediaRect = media.getBoundingClientRect();
    var contentRect = content.getBoundingClientRect();
    var start = mediaRect.bottom;
    var end = mediaRect.top + mediaRect.height * 0.22;
    var distance = start - end;
    var progress = 0;
    if (distance > 0) {
      progress = (start - contentRect.top) / distance;
    }
    progress = Math.min(1, Math.max(0, progress));
    banner.style.setProperty('--k7-award-scale', String(1 - progress * 0.46));
  });
}

function initK7AwardBanner() {
  if (document.documentElement.hasAttribute('data-k7-award-scroll')) {
    k7AwardBannerUpdate();
    return;
  }
  document.documentElement.setAttribute('data-k7-award-scroll', '');

  var ticking = false;
  var onScroll = function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      k7AwardBannerUpdate();
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  k7AwardBannerUpdate();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7AwardBanner, { once: true });
} else {
  initK7AwardBanner();
}

document.addEventListener('shopify:section:load', function() {
  initK7AwardBanner();
});

/* k7-award-banner end */

/* k7-lipscore-card-rating start */

function k7DecorateLipscoreCard(widget) {
  if (!widget || !widget.closest('.lipscore-rating-card, .k7-lipscore-rating')) return;
  var raw = parseFloat(widget.getAttribute('data-ls-product-rating'));
  var votes = parseInt(widget.getAttribute('data-ls-product-votes'), 10);
  var meta = widget.querySelector('.k7-lipscore-card-meta');
  if (!votes || isNaN(raw) || raw <= 0) {
    if (meta) meta.remove();
    return;
  }
  var lang = document.documentElement.lang || 'de';
  var label = (raw / 2).toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' (' + votes + ')';
  if (!meta) {
    meta = document.createElement('span');
    meta.className = 'k7-lipscore-card-meta';
    widget.appendChild(meta);
  }
  if (meta.textContent !== label) meta.textContent = label;
}

function k7ScanLipscoreCards(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.lipscore-rating-card .lipscore-rating-small, .k7-lipscore-rating .lipscore-rating-small').forEach(k7DecorateLipscoreCard);
}

function initK7LipscoreCardRatings() {
  if (!document.body || document.body.getAttribute('data-k7-lipscore-cards') === '1') return;
  document.body.setAttribute('data-k7-lipscore-cards', '1');
  k7ScanLipscoreCards(document);
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        k7DecorateLipscoreCard(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(function(node) {
        if (!node || node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('k7-lipscore-card-meta')) return;
        var widget = node.classList && node.classList.contains('lipscore-rating-small') ? node : node.closest && node.closest('.lipscore-rating-small');
        if (widget) k7DecorateLipscoreCard(widget);
        if (node.querySelectorAll) k7ScanLipscoreCards(node);
      });
    });
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-ls-product-rating', 'data-ls-product-votes']
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7LipscoreCardRatings, { once: true });
} else {
  initK7LipscoreCardRatings();
}

/* k7-lipscore-card-rating end */

/* k7-mix-builder start */

function k7MixBuilderMoney(cents, format) {
  format = format || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount}}';
  return window.k7FormatMoney(cents, format);
}

function k7MixBuilderShopRoot() {
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
  return '/';
}

function initK7MixBuilder(root) {
  if (!root || root.getAttribute('data-k7-ready') === 'true') return;
  var configEl = root.querySelector('[data-k7-mix-builder-config]');
  if (!configEl) return;
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }
  root.setAttribute('data-k7-ready', 'true');

  var qty = {};
  var lastImage = config.knob || '';
  var busy = false;
  var sheetReturn = null;
  var itemsEl = root.querySelector('[data-k7-mix-builder-items]');
  var mobileQuery = window.matchMedia('(max-width: 860px)');

  function money(cents) {
    return k7MixBuilderMoney(cents, config.moneyFormat);
  }

  function cards() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-k7-mix-builder-card]'));
  }

  function cardById(id) {
    return root.querySelector('[data-k7-mix-builder-card][data-variant-id="' + id + '"]');
  }

  function text(template, values) {
    var output = template || '';
    Object.keys(values || {}).forEach(function(key) {
      output = output.split(key).join(String(values[key]));
    });
    return output;
  }

  function showError(message) {
    root.querySelectorAll('[data-k7-mix-builder-error]').forEach(function(el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  function setUnlock(name, on) {
    var item = root.querySelector('[data-unlock="' + name + '"]');
    if (!item) return;
    item.classList.toggle('is-on', on);
    var tag = item.querySelector('[data-unlock-tag]');
    if (tag) tag.textContent = on ? '✓' : (item.getAttribute('data-tag') || '');
  }

  function fillNext(el, state) {
    if (!el) return;
    el.replaceChildren();
    if (!state.ok) {
      el.textContent = text(config.texts.nextMix, { __COUNT__: state.left, __UNIT__: config.unit });
      return;
    }
    if (state.nextTier) {
      el.append(document.createTextNode(text(config.texts.nextDiscount, { __COUNT__: state.nextTier.left, __UNIT__: config.unit }) + ' '));
      var upcoming = document.createElement('span');
      upcoming.className = 'k7-mix-builder__hl';
      upcoming.textContent = text(config.texts.discountBadge, { __PERCENT__: state.nextTier.pct });
      el.append(upcoming);
      return;
    }
    if (config.discounts && state.pct > 0) {
      var active = document.createElement('span');
      active.className = 'k7-mix-builder__hl';
      active.textContent = text(config.texts.discountBadge, { __PERCENT__: state.pct });
      el.append(active, document.createTextNode(' ' + (config.texts.discountActiveSuffix || '')));
      return;
    }
    el.textContent = config.texts.ready || '';
  }

  function setTracks(progress, total) {
    root.querySelectorAll('[data-k7-mix-builder-fill]').forEach(function(fill) {
      fill.style.width = (progress * 100) + '%';
    });
    root.querySelectorAll('[data-k7-mix-builder-knob]').forEach(function(knob) {
      var wide = knob.hasAttribute('data-knob-sm') ? 54 : 72;
      var inset = wide / 2;
      knob.style.left = 'calc(' + inset + 'px + (100% - ' + wide + 'px) * ' + progress + ')';
      if (lastImage) knob.style.backgroundImage = 'url("' + String(lastImage).replace(/"/g, '') + '")';
    });
    root.querySelectorAll('[data-k7-mix-builder-progress]').forEach(function(bar) {
      bar.setAttribute('aria-valuenow', String(total));
      bar.setAttribute('aria-valuemax', String(config.progressMax || 1));
    });
  }

  function renderChips(active) {
    var box = root.querySelector('[data-k7-mix-builder-chips]');
    if (!box) return;
    box.replaceChildren();
    if (!active.length) {
      var empty = document.createElement('p');
      empty.className = 'k7-mix-builder__empty';
      empty.textContent = config.texts.empty || '';
      box.appendChild(empty);
      return;
    }
    active.forEach(function(item) {
      var chip = document.createElement('span');
      chip.className = 'k7-mix-builder__chip';
      chip.style.setProperty('--k7-mix-card', item.card.style.getPropertyValue('--k7-mix-card'));
      var dot = document.createElement('i');
      dot.setAttribute('aria-hidden', 'true');
      var count = document.createElement('b');
      count.textContent = item.qty + '×';
      chip.append(dot, count, document.createTextNode(' ' + (item.card.getAttribute('data-title') || '')));
      box.appendChild(chip);
    });
  }

  function renderLines(active) {
    var list = root.querySelector('[data-k7-mix-builder-lines]');
    var template = root.querySelector('[data-k7-mix-builder-line-template]');
    if (!list || !template || !template.content.firstElementChild) return;
    var map = {};
    list.querySelectorAll('[data-line]').forEach(function(line) {
      map[line.getAttribute('data-variant-id')] = line;
    });
    var keep = {};
    active.forEach(function(item) {
      keep[item.id] = true;
      var line = map[item.id];
      if (!line) {
        line = template.content.firstElementChild.cloneNode(true);
        line.setAttribute('data-variant-id', item.id);
        var thumb = line.querySelector('.k7-mix-builder__thumb');
        thumb.style.setProperty('--k7-mix-card', item.card.style.getPropertyValue('--k7-mix-card'));
        var image = item.card.getAttribute('data-image');
        if (image) {
          var img = document.createElement('img');
          img.alt = '';
          img.src = image;
          img.width = 80;
          img.height = 54;
          thumb.appendChild(img);
        }
        line.querySelector('b').textContent = item.card.getAttribute('data-title') || '';
        var weight = item.card.getAttribute('data-weight');
        var priceLabel = item.card.getAttribute('data-price-label') || money(item.price);
        line.querySelector('.k7-mix-builder__line-name span').textContent = weight ? weight + ' · ' + priceLabel : priceLabel;
        var cardMinus = item.card.querySelector('[data-delta="-1"]');
        var cardPlus = item.card.querySelector('[data-delta="1"]');
        var cardInput = item.card.querySelector('[data-k7-mix-builder-input]');
        if (cardMinus) line.querySelector('[data-delta="-1"]').setAttribute('aria-label', cardMinus.getAttribute('aria-label') || '');
        if (cardPlus) line.querySelector('[data-delta="1"]').setAttribute('aria-label', cardPlus.getAttribute('aria-label') || '');
        if (cardInput) line.querySelector('[data-k7-mix-builder-input]').setAttribute('aria-label', cardInput.getAttribute('aria-label') || '');
        line.querySelector('[data-k7-mix-builder-input]').max = item.card.getAttribute('data-max') || '99';
      }
      var input = line.querySelector('[data-k7-mix-builder-input]');
      var minus = line.querySelector('[data-delta="-1"]');
      var plus = line.querySelector('[data-delta="1"]');
      var max = parseInt(item.card.getAttribute('data-max'), 10) || 99;
      if (input && document.activeElement !== input) input.value = String(item.qty);
      if (minus) minus.disabled = item.qty <= 0;
      if (plus) plus.disabled = item.qty >= max;
      list.appendChild(line);
    });
    list.querySelectorAll('[data-line]').forEach(function(line) {
      if (!keep[line.getAttribute('data-variant-id')]) line.remove();
    });
  }

  function render() {
    var total = 0;
    var sum = 0;
    var active = [];
    cards().forEach(function(card) {
      var id = card.getAttribute('data-variant-id');
      var count = qty[id] || 0;
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var max = parseInt(card.getAttribute('data-max'), 10);
      if (isNaN(max)) max = 99;
      total += count;
      sum += count * price;
      var input = card.querySelector('[data-k7-mix-builder-input]');
      var minus = card.querySelector('[data-delta="-1"]');
      var plus = card.querySelector('[data-delta="1"]');
      if (input && document.activeElement !== input) input.value = String(count);
      if (minus) minus.disabled = count <= 0;
      if (plus) plus.disabled = count >= max;
      card.classList.toggle('is-active', count > 0);
      var badge = card.querySelector('[data-k7-mix-builder-badge]');
      if (badge) {
        badge.hidden = count <= 0;
        badge.textContent = text(config.texts.selected, { __COUNT__: count });
      }
      if (count > 0) active.push({ id: id, qty: count, price: price, card: card });
    });

    var min = config.min || 1;
    var left = Math.max(0, min - total);
    var ok = total >= min;
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-k7-mix-builder-tier]'));
    var activeTier = null;
    var nextTier = null;
    tiers.forEach(function(tier) {
      var tierQty = parseInt(tier.getAttribute('data-qty'), 10) || 0;
      var tierPct = parseInt(tier.getAttribute('data-pct'), 10) || 0;
      var on = !!(config.discounts && total >= tierQty);
      tier.classList.toggle('is-on', on);
      if (on && (!activeTier || tierQty >= activeTier.qty)) activeTier = { qty: tierQty, pct: tierPct };
      if (config.discounts && tierPct > 0 && total < tierQty && !nextTier) nextTier = { qty: tierQty, pct: tierPct, left: tierQty - total };
    });
    var pct = config.discounts && activeTier ? activeTier.pct : 0;
    var grand = pct > 0 ? Math.round(sum * (100 - pct) / 100) : sum;
    var progressMax = config.progressMax || min || 1;
    var progress = Math.min(1, total / progressMax);
    var state = { ok: ok, left: left, pct: pct, nextTier: nextTier };

    root.querySelectorAll('[data-k7-mix-builder-next]').forEach(function(el) {
      fillNext(el, state);
    });
    setTracks(progress, total);
    setUnlock('mix', ok);
    setUnlock('ship', ok && config.freeShipping > 0 && grand >= config.freeShipping);
    var discountUnlock = root.querySelector('[data-unlock="discount"]');
    var discountQty = discountUnlock ? parseInt(discountUnlock.getAttribute('data-qty'), 10) || 0 : 0;
    setUnlock('discount', !!(config.discounts && discountQty && total >= discountQty));

    var countEl = root.querySelector('[data-k7-mix-builder-count]');
    if (countEl) countEl.textContent = String(total);
    var discountRow = root.querySelector('[data-k7-mix-builder-discount]');
    if (discountRow) {
      var showDiscount = pct > 0 && sum > grand;
      discountRow.hidden = !showDiscount;
      if (showDiscount) {
        var discountLabel = root.querySelector('[data-k7-mix-builder-discount-label]');
        var discountAmount = root.querySelector('[data-k7-mix-builder-discount-amount]');
        if (discountLabel) discountLabel.textContent = text(config.texts.discountRow, { __PERCENT__: pct });
        if (discountAmount) discountAmount.textContent = '−' + money(sum - grand);
      }
    }
    var totalEl = root.querySelector('[data-k7-mix-builder-total]');
    if (totalEl) totalEl.textContent = money(total > 0 ? grand : 0);
    var avgEl = root.querySelector('[data-k7-mix-builder-avg]');
    if (avgEl) avgEl.textContent = total > 0 ? money(Math.round(grand / total)) : '–';

    var shipEl = root.querySelector('[data-k7-mix-builder-ship]');
    if (shipEl && config.freeShipping > 0) {
      var shipOk = ok && grand >= config.freeShipping;
      shipEl.classList.toggle('is-ok', shipOk);
      shipEl.classList.toggle('bold', shipOk);
      if (shipOk) shipEl.textContent = config.texts.shipFree;
      else if (!total) shipEl.textContent = text(config.texts.shipFrom, { __AMOUNT__: config.shipLabel || money(config.freeShipping) });
      else shipEl.textContent = text(config.texts.shipLeft, { __AMOUNT__: money(Math.max(0, config.freeShipping - grand)) });
    }

    var deliveryEl = root.querySelector('[data-k7-mix-builder-delivery]');
    if (deliveryEl) {
      deliveryEl.hidden = !active.some(function(item) {
        return item.card.getAttribute('data-extended-delivery') === 'true';
      });
    }

    renderChips(active);
    renderLines(active);

    if (itemsEl) {
      itemsEl.classList.toggle('is-empty', active.length === 0);
      if (!active.length) {
        itemsEl.classList.remove('is-open');
        var toggle = root.querySelector('[data-k7-mix-builder-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }
    var sortsEl = root.querySelector('[data-k7-mix-builder-sorts]');
    if (sortsEl) {
      sortsEl.textContent = !active.length ? '' : (active.length === 1 ? config.texts.sortsOne : text(config.texts.sortsOther, { __COUNT__: active.length }));
    }

    var label = text(config.texts.atcChoose, { __COUNT__: min, __UNIT__: config.unit });
    if (ok) label = config.texts.atc;
    else if (total > 0) label = text(config.texts.atcMore, { __COUNT__: left, __UNIT__: config.unit });
    root.querySelectorAll('[data-k7-mix-builder-atc-label]').forEach(function(el) {
      el.textContent = label;
    });
    root.querySelectorAll('[data-k7-mix-builder-atc] button').forEach(function(button) {
      button.disabled = busy || !ok;
    });

    var mobilePrice = root.querySelector('[data-k7-mix-builder-mobile-price]');
    if (mobilePrice) mobilePrice.textContent = money(total > 0 ? grand : 0);
    var mobileOff = root.querySelector('[data-k7-mix-builder-mobile-off]');
    if (mobileOff) {
      mobileOff.hidden = !(pct > 0);
      mobileOff.textContent = '−' + pct + ' %';
    }
    var mobileHint = root.querySelector('[data-k7-mix-builder-mobile-hint]');
    if (mobileHint) mobileHint.textContent = total + ' ' + (config.unit || '');
  }

  function setQty(id, value) {
    var card = cardById(id);
    if (!card) return;
    var max = parseInt(card.getAttribute('data-max'), 10);
    if (isNaN(max)) max = 99;
    var next = Math.max(0, Math.min(max, value));
    if (next > (qty[id] || 0)) {
      var image = card.getAttribute('data-image');
      if (image) lastImage = image;
    }
    qty[id] = next;
    render();
  }

  function placeClose() {
    var summary = root.querySelector('[data-k7-mix-builder-summary]');
    var closeButton = root.querySelector('[data-k7-mix-builder-close]');
    if (!summary || !closeButton) return;
    closeButton.style.bottom = (summary.offsetHeight + 12) + 'px';
  }

  function setSheet(open) {
    if (open && !mobileQuery.matches) return;
    root.classList.toggle('is-sheet', open);
    document.documentElement.classList.toggle('k7-mix-builder-sheet-open', open && mobileQuery.matches);
    root.querySelectorAll('[data-k7-mix-builder-sheet-open]').forEach(function(button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var summary = root.querySelector('[data-k7-mix-builder-summary]');
    if (summary) {
      if (open) {
        summary.setAttribute('role', 'dialog');
        summary.setAttribute('aria-modal', 'true');
      } else {
        summary.removeAttribute('role');
        summary.removeAttribute('aria-modal');
      }
    }
    placeClose();
    var closeButton = root.querySelector('[data-k7-mix-builder-close]');
    if (open && closeButton) {
      sheetReturn = document.activeElement;
      closeButton.focus();
    } else if (!open && sheetReturn && sheetReturn.focus) {
      sheetReturn.focus();
      sheetReturn = null;
    }
  }

  function cartDrawerSectionId() {
    if (window.k7Cart && typeof window.k7Cart.getSectionId === 'function') return window.k7Cart.getSectionId();
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return null;
    var wrapper = cartDrawer.closest('.shopify-section');
    if (wrapper && wrapper.id) return wrapper.id.replace('shopify-section-', '');
    return cartDrawer.getAttribute('data-section-id') || null;
  }

  function applyCartDrawerSection(cartContent) {
    var cartDrawer = document.getElementById('cart-drawer');
    var sectionId = cartDrawerSectionId();
    var markup = cartDrawer && sectionId && cartContent.sections && cartContent.sections[sectionId];
    if (!markup) return;
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var nextDrawer = parsed.querySelector('.cart-drawer');
    if (!nextDrawer) return;
    var nextInner = nextDrawer.querySelector('.cart-drawer__inner');
    var currentInner = cartDrawer.querySelector('.cart-drawer__inner');
    if (!currentInner) {
      cartDrawer.replaceChildren(document.createRange().createContextualFragment(nextDrawer.innerHTML));
      return;
    }
    if (!nextInner) return;
    currentInner.innerHTML = nextInner.innerHTML;
    var footer = cartDrawer.querySelector('[slot="footer"]');
    var nextFooter = nextDrawer.querySelector('[slot="footer"]');
    if (footer && nextFooter) footer.replaceChildren.apply(footer, Array.prototype.slice.call(nextFooter.childNodes));
  }

  async function addToCart() {
    if (busy) return;
    var items = [];
    cards().forEach(function(card) {
      var id = parseInt(card.getAttribute('data-variant-id'), 10);
      var max = parseInt(card.getAttribute('data-max'), 10);
      if (isNaN(max)) max = 99;
      var count = Math.min(qty[card.getAttribute('data-variant-id')] || 0, max);
      if (count > 0) items.push({ id: id, quantity: count, properties: { _mix_match: '1' } });
    });
    if (!items.length) return;
    busy = true;
    showError('');
    var buttons = root.querySelectorAll('[data-k7-mix-builder-atc] button');
    buttons.forEach(function(button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    });
    var settings = window.themeVariables && window.themeVariables.settings || {};
    try {
      var sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      var cartSectionId = cartDrawerSectionId();
      if (cartSectionId && sectionsToBundle.indexOf(cartSectionId) === -1) sectionsToBundle.push(cartSectionId);
      var response = await fetch(k7MixBuilderShopRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname
        })
      });
      var responseJson = await response.json();
      buttons.forEach(function(button) {
        button.removeAttribute('aria-busy');
      });
      if (!response.ok) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        throw new Error(responseJson.description || responseJson.message || config.texts.addError);
      }
      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = k7MixBuilderShopRoot() + 'cart';
        return;
      }
      var cartContent = await (await fetch(k7MixBuilderShopRoot() + 'cart.js')).json();
      cartContent.sections = responseJson.sections || {};
      if (cartSectionId && !cartContent.sections[cartSectionId]) {
        var drawerHtml = await (await fetch(k7MixBuilderShopRoot() + '?section_id=' + encodeURIComponent(cartSectionId))).text();
        cartContent.sections[cartSectionId] = drawerHtml;
      }
      var addedItems = Object.prototype.hasOwnProperty.call(responseJson, 'items') ? responseJson.items : [responseJson];
      applyCartDrawerSection(cartContent);
      document.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: addedItems, cart: cartContent }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cartContent }
      }));
      if (settings.cartType === 'drawer') {
        var cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
      }
      qty = {};
      lastImage = config.knob || '';
      sheetReturn = null;
      setSheet(false);
    } catch (error) {
      showError((error && error.message) || config.texts.addError);
    } finally {
      busy = false;
      buttons.forEach(function(button) {
        button.removeAttribute('aria-busy');
      });
      render();
    }
  }

  root.addEventListener('click', function(event) {
    var step = event.target.closest('[data-k7-mix-builder-step]');
    var atc = event.target.closest('[data-k7-mix-builder-atc] button');
    if ((step || atc) && busy) return;
    if (step) {
      var host = step.closest('[data-variant-id]');
      if (!host) return;
      var id = host.getAttribute('data-variant-id');
      var delta = parseInt(step.getAttribute('data-delta'), 10) || 0;
      setQty(id, (qty[id] || 0) + delta);
      return;
    }
    var toggle = event.target.closest('[data-k7-mix-builder-toggle]');
    if (toggle) {
      if (!itemsEl || itemsEl.classList.contains('is-empty')) return;
      var open = itemsEl.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (event.target.closest('[data-k7-mix-builder-sheet-open]')) {
      setSheet(!root.classList.contains('is-sheet'));
      return;
    }
    if (event.target.closest('[data-k7-mix-builder-close]') || event.target.closest('[data-k7-mix-builder-scrim]')) {
      setSheet(false);
      return;
    }
    if (atc && !atc.disabled) {
      event.preventDefault();
      addToCart();
    }
  });

  root.addEventListener('input', function(event) {
    var input = event.target.closest('[data-k7-mix-builder-input]');
    if (!input || busy) return;
    if (input.value.trim() === '') return;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) return;
    var host = input.closest('[data-variant-id]');
    if (!host) return;
    setQty(host.getAttribute('data-variant-id'), value);
  });

  root.addEventListener('focusout', function(event) {
    var input = event.target.closest('[data-k7-mix-builder-input]');
    if (!input) return;
    var host = input.closest('[data-variant-id]');
    if (!host) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 0;
    setQty(host.getAttribute('data-variant-id'), value);
  });

  root.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && root.classList.contains('is-sheet')) setSheet(false);
  });

  function onModeChange() {
    if (!mobileQuery.matches) setSheet(false);
    else if (root.classList.contains('is-sheet')) placeClose();
  }
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onModeChange);
  else if (mobileQuery.addListener) mobileQuery.addListener(onModeChange);
  window.addEventListener('resize', function() {
    if (root.classList.contains('is-sheet')) placeClose();
  });

  render();
}

function bootK7MixBuilder(scope) {
  var context = scope && scope.querySelectorAll ? scope : document;
  context.querySelectorAll('[data-k7-mix-builder]').forEach(initK7MixBuilder);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { bootK7MixBuilder(document); });
} else {
  bootK7MixBuilder(document);
}

document.addEventListener('shopify:section:load', function(event) {
  bootK7MixBuilder(event.target);
});

document.addEventListener('shopify:section:unload', function(event) {
  if (event.target.querySelector('[data-k7-mix-builder].is-sheet')) {
    document.documentElement.classList.remove('k7-mix-builder-sheet-open');
  }
});

/* k7-mix-builder end */

/* k7-voucher-banner-visibility start */

function initK7VoucherBannerVisibility() {
  var allowed = ['/collections/alle-riegel', '/collections/klassisch'];
  var path = window.location.pathname.replace(/\/+$/, '');
  if (allowed.indexOf(path) !== -1) return;
  document.querySelectorAll('.k7-voucher-banner__card').forEach(function(el) {
    el.style.setProperty('display', 'none', 'important');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initK7VoucherBannerVisibility, { once: true });
} else {
  initK7VoucherBannerVisibility();
}

document.addEventListener('shopify:section:load', initK7VoucherBannerVisibility);

/* k7-voucher-banner-visibility end */